import {
    HttpClient,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class FileUploadService {
    constructor(
        private _http: HttpClient,
    ) { }

    public uploadFiles<T = any>(files: File[], endpoint: string) {
        const formData = new FormData();
        files.forEach(file => formData.append('uploads[]', file, file.name));
        const req = new HttpRequest('POST', endpoint, formData, {
            reportProgress: true,
        });
        return this._http.request<T>(req);
    }

    public isFileItemValid(file: File, allowedFileExtensions: Array<string> | null, maxSize?: number): boolean {
        if (!file || !file.name) { return false; }
        if (maxSize && file.size > maxSize) { return false; }
        if (allowedFileExtensions == null) { return true; }

        const fileExtension = file.name.split('.').pop();

        return allowedFileExtensions.includes(`.${fileExtension}`);
    }
}
